import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { StripeService } from '../../core/services/stripe.service';
import { ModalService } from '../../core/services/modal.service';
import { SavedPaymentsMethodsService } from '../../core/services/data/saved-payment-methods.service';

@Component({
	selector: 'app-list-cards-modal',
	templateUrl: './list-cards-modal.component.html',
	styleUrls: ['./list-cards-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ListCardsModalComponent implements OnInit {
	@Input() listCards;

	@Input() author;

	@Input() customer;

	@Input() cardCustomer;

	@Input() currentSubscription;

	public cardSelected = false;

	public loading = false;

	public buttonText = { confirm: 'Confirm', cancel: 'Cancel' };

	public myDir;

	public confirmText;

	public cardRemove;

	public successText;

	public success;

	public check;

	public urlLocalStorage;

	constructor(
		private ms: ModalService,
		private router: Router,
		private ss: StripeService,
		private savedPaymentMethodsService: SavedPaymentsMethodsService,
	) {
	}

	ngOnInit() {
		this.getCards(false);
	}

	getCards(check) {
		if (check.default) {
			this.ss.getCustomer(this.author.stripeCustomerId).subscribe((data: any) => {
				if (data.success) {
					const customerResult = data.customer;
					this.customer = {
						customerId: this.author.stripeCustomerId,
						email: this.author.username,
						name: `${this.author.firstName} ${this.author.lastName}`,
						paymentMethodId: customerResult.invoice_settings
							? customerResult.invoice_settings.default_payment_method
							: undefined,
						subscriptionId: customerResult.subscription
							? customerResult.subscription.id
							: undefined,
					};
				}
			});
		}
		this.loading = true;
		const arrayCards = this.ss.cards;

		this.savedPaymentMethodsService.getSavedCards().subscribe((cards: any) => {
			this.listCards = cards;
			this.listCards.forEach((card, index) => {
				const cardBrand = card.card.brand;
				for (const [key, value] of Object.entries(arrayCards[0])) {
					if (`${key}` === cardBrand) {
						card.card.brand = `${value}`;
					}
				}
			});
			this.loading = false;
		});
	}

	ok() {
		this.ms.close('list-cards');
	}

	cancel() {
		this.ms.close('list-cards');
	}

	addNewCard() {
		this.cardSelected = false;
		this.ms.close('list-cards');
		this.ms.open('add-card-form');
	}

	editCard(card) {
		this.cardSelected = card;
		this.ms.close('list-cards');
		this.ms.open('add-card-form');
	}

	removeCard(card) {
		this.confirmText = 'Are you sure you want to delete the card?';
		this.ms.open('remove-Card');
		this.cardRemove = card;
	}

	comfirmRemoveCard(event) {
		if (event) {
			// this.ss.removeCard(this.cardRemove.id).subscribe((data: any) => {
			// 	if (data.success) {
			// 		this.successText = 'Card removed successfully';
			// 		this.ms.open('success-removeCard');
			// 	}
			// });
			// Request above removes the payment method from stripe. This one removes it JUST from our DB. We might want both. - Jordan 6/20/2024
			this.savedPaymentMethodsService.remove(this.cardRemove.id).subscribe((data: any) => {
				if (data.success) {
					this.successText = 'Card removed successfully';
					this.ms.open('success-removeCard');
				}
			});
		}
	}

	updatePrimaryCard(card) {
		if (this.listCards.length <= 1) {
			return;
		}
		this.loading = true;
		this.customer.paymentMethodId = card.id;
		this.ss.defaultCustomerPaymentMethod(this.author.stripeCustomerId, card.id).subscribe((data: any) => {
			if (data.success) {
				this.loading = false;
				this.successText = 'Card set as primary successfully';
				this.ms.open('success-removeCard');
			} else {
				this.loading = false;
			}
		});
	}
}
